import type { RoleSort, RoleSortField } from "./roles.types";

/** Ordem de quando nenhuma coluna foi escolhida: Nome A–Z (HU técnica 722, P-14). */
export const DEFAULT_ROLE_SORT: RoleSort = { field: "nome", direction: "asc" };

const SORT_FIELDS: readonly RoleSortField[] = [
  "codigo",
  "nome",
  "permissoes",
  "quantidadeUsuarios",
];

export function isRoleSortField(value: unknown): value is RoleSortField {
  return SORT_FIELDS.includes(value as RoleSortField);
}
